const ImageSet = () => {
    return (<div>image set</div>)
}

export default ImageSet;